import { formatThousandUnitDefaultTwo, keepTwoOrNull } from '@/utils/utils';
import dayjs from 'dayjs';
import { DeviceDetailDataPoint } from '../../hooks/useDeviceDetail';

type ChartOptionProps = {
  data: DeviceDetailDataPoint[];
  color: string;
  unit?: string;
  formatStr: string;
  upperLimit?: number | null;
  lowerLimit?: number | null;
  propertyName?: string;
};
export const getDeviceDetailChartOption = ({
  data,
  color,
  unit,
  formatStr,
  upperLimit,
  lowerLimit,
  propertyName,
}: ChartOptionProps) => {
  const displayUnit = unit?.trim();
  const tooltipUnit = displayUnit?.toLowerCase() === 'ph' ? '' : displayUnit;

  return {
    tooltip: {
      trigger: 'axis',
      borderColor: 'transparent',
      formatter: (params: any) => {
        const list = Array.isArray(params) ? params : [params];
        const title = list[0]?.axisValue ?? '';
        const lines = list.map(item => {
          const value = formatThousandUnitDefaultTwo(item.value);
          return `${item.marker ?? ''}${item.seriesName ?? ''}: ${value}${tooltipUnit ?? ''}`;
        });

        return [title, ...lines].filter(Boolean).join('<br/>');
      },
    },
    grid: {
      left: 60,
      right: 10,
      top: 40,
      bottom: 10,
      containLabel: true,
    },
    legend: {
      right: 10,
      top: 0,
      itemWidth: 12,
      itemHeight: 12,
    },
    xAxis: {
      type: 'category',
      data: data.map(d => dayjs(d.time, 'x').format(formatStr)),
    },
    yAxis: {
      type: 'value',
      name: `${propertyName}(${unit})`,
    },
    series: [
      {
        type: 'bar',
        name: propertyName,
        data: data.map(d => keepTwoOrNull(d.value)),
        itemStyle: { color },
        barMaxWidth: 24,
        markLine: {
          silent: true,
          symbol: 'none',
          data: [
            ...(upperLimit
              ? [
                  {
                    yAxis: upperLimit,
                    label: {
                      formatter: `指标上限: ${upperLimit}`,
                      position: 'insideEndTop',
                      color: '#FFCB47',
                      fontSize: 14,
                    },
                    lineStyle: { color: '#FFCB47', type: 'dashed', width: 1 },
                  },
                ]
              : []),
            ...(lowerLimit
              ? [
                  {
                    yAxis: lowerLimit,
                    label: {
                      formatter: `指标下限: ${lowerLimit}`,
                      position: 'insideEndBottom',
                      color: '#FF4D4F',
                      fontSize: 14,
                    },
                    lineStyle: { color: '#FF4D4F', type: 'dashed', width: 1 },
                  },
                ]
              : []),
          ],
        },
      },
    ],
  };
};
